var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLearn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 208,
    height: 173,
    viewBox: "0 0 208 173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10489",
    "data-name": "Rectangle 10489",
    width: 208,
    height: 173,
    transform: "translate(1084 2965)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10475",
    "data-name": "Rectangle 10475",
    width: 140,
    height: 140,
    transform: "translate(4268 1856)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_87726",
    "data-name": "Mask Group 87726",
    transform: "translate(-1084 -2965)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9883",
    "data-name": "Path 9883",
    d: "M2384.853-2209.844c29.28-30.424,75.613-36.031,111.345-16.62s62.455,62.252,55.522,96.373-39.856,39.748-83.017,46.078-74.052.374-89.628-20.758S2355.573-2179.42,2384.853-2209.844Z",
    transform: "translate(-1154.514 5336.543) rotate(-3)",
    fill: "#ddffe3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_87718",
    "data-name": "Mask Group 87718",
    transform: "translate(-3156 1123)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-idea-5647268",
    transform: "translate(4284.022 1866.623)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9885",
    "data-name": "Path 9885",
    d: "M125.6,107.541H35.64a9.007,9.007,0,0,1-9-9V40.968a9.006,9.006,0,0,1,9-9h10.8a1.8,1.8,0,0,1,0,3.6H35.64a5.4,5.4,0,0,0-5.4,5.4V98.545a5.4,5.4,0,0,0,5.4,5.4H125.6a5.4,5.4,0,0,0,5.4-5.4V40.968a5.4,5.4,0,0,0-5.4-5.4h-10.8a1.8,1.8,0,0,1,0-3.6h10.8a9.006,9.006,0,0,1,9,9V98.545a9.007,9.007,0,0,1-9,9Z",
    transform: "translate(-26.643 -4.981)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9886",
    "data-name": "Path 9886",
    d: "M122,122.743H39.238a12.61,12.61,0,0,1-12.594-12.595,1.8,1.8,0,0,1,1.8-1.8H66.226a1.8,1.8,0,0,1,1.272.527l3.071,3.071h20.1l3.071-3.071a1.8,1.8,0,0,1,1.272-.527H132.8a1.8,1.8,0,0,1,1.8,1.8A12.61,12.61,0,0,1,122,122.743Zm-91.582-10.8a9.011,9.011,0,0,0,8.815,7.2H122a9.011,9.011,0,0,0,8.815-7.2H95.759l-3.071,3.071h0a1.8,1.8,0,0,1-1.272.527H69.825a1.8,1.8,0,0,1-1.271-.527l-3.071-3.071Z",
    transform: "translate(-26.643 -3.99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9887",
    "data-name": "Path 9887",
    d: "M121.912,100.25H39.145a5.4,5.4,0,0,1-5.4-5.4V44.473a5.405,5.405,0,0,1,5.4-5.4h9a1.8,1.8,0,0,1,0,3.6h-9a1.8,1.8,0,0,0-1.8,1.8v50.38a1.8,1.8,0,0,0,1.8,1.8h82.766a1.8,1.8,0,0,0,1.8-1.8V44.473a1.8,1.8,0,0,0-1.8-1.8h-9a1.8,1.8,0,0,1,0-3.6h9a5.405,5.405,0,0,1,5.4,5.4v50.38a5.4,5.4,0,0,1-5.4,5.4Z",
    transform: "translate(-26.551 -4.889)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9888",
    "data-name": "Path 9888",
    d: "M87.495,71.9H73.1a1.8,1.8,0,0,1-1.8-1.8,14.179,14.179,0,0,0-6.67-11.859,28.788,28.788,0,1,1,31.107.146A13.758,13.758,0,0,0,89.3,70.032a1.861,1.861,0,0,1-1.8,1.87ZM74.809,68.3H85.786a17.363,17.363,0,0,1,8.022-12.95,25.268,25.268,0,1,0-27.217-.127A17.881,17.881,0,0,1,74.81,68.3Z",
    transform: "translate(-26.321 -5.327)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9889",
    "data-name": "Path 9889",
    d: "M80.045,83.619a1.806,1.806,0,0,1-.805-.19l-7.2-3.6a1.8,1.8,0,0,1-.995-1.609v-3.6a1.8,1.8,0,0,1,3.6,0v2.486l5.4,2.7,5.4-2.7V74.623a1.8,1.8,0,0,1,3.6,0v3.6a1.8,1.8,0,0,1-.995,1.609l-7.2,3.6a1.806,1.806,0,0,1-.805.19Z",
    transform: "translate(-26.067 -4.451)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9890",
    "data-name": "Path 9890",
    d: "M53.447,76.655a1.8,1.8,0,0,1-1.8-1.8V62.261a3.6,3.6,0,1,0-3.6,3.6,1.8,1.8,0,1,1,0,3.6,7.2,7.2,0,1,1,7.2-7.2V74.856a1.8,1.8,0,0,1-1.8,1.8Z",
    transform: "translate(-26.459 -4.681)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9891",
    "data-name": "Path 9891",
    d: "M103.043,87.31a1.8,1.8,0,0,1-1.8-1.8V72.917a7.2,7.2,0,1,1,7.2,7.2,1.8,1.8,0,0,1,0-3.6,3.6,3.6,0,1,0-3.6-3.6V85.512h0a1.8,1.8,0,0,1-1.8,1.8Z",
    transform: "translate(-25.675 -4.543)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9892",
    "data-name": "Path 9892",
    d: "M63.966,81.867a1.8,1.8,0,0,1-1.8-1.8v-9a1.8,1.8,0,0,1,3.6,0v9a1.8,1.8,0,0,1-1.8,1.8Z",
    transform: "translate(-26.182 -4.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9893",
    "data-name": "Path 9893",
    d: "M63.966,88.88a1.8,1.8,0,0,1-1.8-1.8v-1.8a1.8,1.8,0,1,1,3.6,0v1.8a1.8,1.8,0,0,1-1.8,1.8Z",
    transform: "translate(-26.182 -4.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9894",
    "data-name": "Path 9894",
    d: "M88.834,92.479a1.8,1.8,0,0,1-1.8-1.8v-5.4a1.8,1.8,0,0,1,3.6,0v5.4a1.8,1.8,0,0,1-1.8,1.8Z",
    transform: "translate(-25.86 -4.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9895",
    "data-name": "Path 9895",
    d: "M110.147,56.977a1.8,1.8,0,0,1-1.8-1.8v-7.2a1.8,1.8,0,1,1,3.6,0v7.2a1.8,1.8,0,0,1-1.8,1.8Z",
    transform: "translate(-25.583 -4.797)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9896",
    "data-name": "Path 9896",
    d: "M110.147,64.013a1.8,1.8,0,0,1-1.8-1.8v-1.8a1.8,1.8,0,1,1,3.6,0v1.8a1.8,1.8,0,0,1-1.8,1.8Z",
    transform: "translate(-25.583 -4.635)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9897",
    "data-name": "Path 9897",
    d: "M87.9,46.55a1.8,1.8,0,0,1-.871-.225L80.114,42.5,73.2,46.325a1.8,1.8,0,0,1-2.647-1.864l1.34-8.218-5.663-5.8A1.8,1.8,0,0,1,67.248,27.4L75,26.219,78.486,18.8a1.8,1.8,0,0,1,3.257,0l3.484,7.423L92.98,27.4A1.8,1.8,0,0,1,94,30.439l-5.663,5.8,1.34,8.218h0A1.8,1.8,0,0,1,87.9,46.55Zm-7.784-7.9a1.786,1.786,0,0,1,.87.225l4.541,2.51-.89-5.456h0a1.8,1.8,0,0,1,.488-1.546l3.852-3.948-5.241-.8a1.8,1.8,0,0,1-1.358-1.014L80.114,23.8l-2.263,4.822a1.8,1.8,0,0,1-1.358,1.014l-5.241.8L75.1,34.38a1.8,1.8,0,0,1,.488,1.546l-.89,5.456,4.541-2.51h0a1.786,1.786,0,0,1,.87-.225Z",
    transform: "translate(-26.136 -5.166)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLearn);
export default __webpack_public_path__ + "static/media/Learn.c8768a258ef1f0e2310c3443b8861b3a.svg";
export { ForwardRef as ReactComponent };